import { render, staticRenderFns } from "./BaseCopyButton.vue?vue&type=template&id=5eb0ba6e"
import script from "./BaseCopyButton.vue?vue&type=script&lang=js"
export * from "./BaseCopyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports